/**
 * @Author: WeiZisen
 * @Date: 2021-03-17 14:45:33
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-03-17 14:54:27
 * @Description: 验证规则-用户管理
 * @FilePath: \Vue_RebarProcess\src\validate\system\account.js
 */

export let rules = {
  name: [{ required: true, message: '请填写用户名', trigger: 'blur' }],
  account: [{ required: true, message: '请填写账号', trigger: 'blur' }],
  mobilePhone: [
    { required: true, message: '请填写手机号', trigger: 'blur' },
    {
      required: true,
      pattern: /^1[3-9]\d{9}$/,
      message: '手机号格式错误',
      trigger: 'blur',
    },
  ],
}
